import script from "./VideoUploadDefaultBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoUploadDefaultBox.vue?vue&type=script&setup=true&lang=ts"

import "./VideoUploadDefaultBox.vue?vue&type=style&index=0&id=a22e15e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a22e15e4"]])

export default __exports__